import { render, staticRenderFns } from "./DShareComplianceWireExportNotification.vue?vue&type=template&id=867a8baa&scoped=true&"
import script from "./DShareComplianceWireExportNotification.vue?vue&type=script&lang=js&"
export * from "./DShareComplianceWireExportNotification.vue?vue&type=script&lang=js&"
import style0 from "./DShareComplianceWireExportNotification.vue?vue&type=style&index=0&id=867a8baa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a8baa",
  null
  
)

export default component.exports